export const zIndex = {
    modal: 9999,
    snackbar: 10100,
    tooltip: 10200
};

//# sourceMappingURL=index.js.map